"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listStyle = exports.listWidth = void 0;
const config_1 = require("@/pages/index/config");
const charWidth = 14.01;
const numberWidth = 8;
const letterWidth = 12.6;
const padding = 8;
function getWidth(char, number = 0, letter = 0) {
    const offset = (char + number + letter) > 4 ? 4 : 4;
    return char * charWidth + number * numberWidth + letter * letterWidth + padding * 2 + offset;
}
exports.listWidth = {
    getWidth: getWidth,
    contractNumber: 148 + padding * 2,
    phone: getWidth(0, 12),
    time: 143 + padding * 2,
    date: 83 + padding * 2,
    identityCard: getWidth(0, 18),
    personnelName: getWidth(5),
    businessLine: 104 + padding * 2,
    vin: 160 + padding * 2,
    vehicleEngineModel: 104 + padding * 2,
    vehicleEngineNo: 104 + padding * 2, // 发动机编号
};
exports.listStyle = {
    high: {
        color: config_1.color.link,
        cursor: 'pointer',
        textDecoration: 'underline',
    }
};
